import { BaseFilterProps, BooleanFilter } from 'framework/list';

const ComplianceAllEmployeesFilter = ({ source, label, ...props }: BaseFilterProps) => (
  <BooleanFilter {...props} source={source} label={label} />
);

export default ComplianceAllEmployeesFilter;
